import eventEmitter from 'tiny-emitter/instance'
import isMobile from 'ismobilejs'

class VideoPlayer{
  constructor () {
    this._element = document.querySelector('.js-video-player')
    if (!this._element) return
    this._muteBtn = document.querySelector('.js-mute-btn')
    this._playBtn = document.querySelector('.js-play-btn')
    this._init()
    this.flag = true
  }

  _init() {
    if(!isMobile.phone) {
      this._element.play()
    }

    this._element.addEventListener('ended', () => {
      this._element.play()
      eventEmitter.emit('videoRestarts')
      // this.flag = true
    })

    // this._element.addEventListener('timeupdate', () => {
    //   if (this.flag && this._element.duration - this._element.currentTime < 5) {
    //     eventEmitter.emit('videoRestarts')
    //     this.flag = false
    //   }
    // })

    this._playBtn.addEventListener('click', () => {
      this._element.play()
      this._playBtn.classList.remove('is-active')
      this._muteBtn.classList.add('is-active')
    })

    this._muteBtn.addEventListener('click', () => {
      if(this._element.muted) {
        this._element.muted = false
        this._muteBtn.classList.remove('is-muted')
      } else {
        this._element.muted = true
        this._muteBtn.classList.add('is-muted')
      }
    })
  }
}

export default new VideoPlayer()
